import { installWidgetActivity } from '@/lib/widget-activity';

/**
 * The page's one activity log (PSDK-6558): recording starts at import, the gateway and the
 * router bind to it in `main.tsx` and `app.tsx`. See README, "The run-up to a failure".
 */
export const widgetActivity = installWidgetActivity();
